import { moduleNames } from 'pages/Stores/components/modules';
import { uploadMedia } from 'utils/mediaResourceUtils';
import { VIDEO_MODES, createVideoConfig } from './VideoConfig';

const defaultValues = {
  mode: VIDEO_MODES.EXISTING,
  selectedItems: [],
  name: '',
  video_source: 'url',
  video_url: '',
  video_file: [],
  existing_video_file_id: null,
  existing_video_file_url: null,
};

export const createVideoModule = (useAvailableItems) => ({
  moduleName: moduleNames.VIDEO,
  nameTranslationPath: 'videos.title',
  descriptionTranslationPath: 'videos.moduleDescription',
  iconClassName: 'bi bi-camera-video',
  defaultValues,
  isValid: (values) => {
    if (values.mode === VIDEO_MODES.CUSTOM) {
      if (!values.name?.trim()) return false;
      if (values.video_source === 'url') return !!values.video_url?.trim();
      return (
        values.video_file?.length > 0 ||
        !!values.existing_video_file_id ||
        !!values.existing_video_file_url
      );
    }
    return values.selectedItems?.length === 1;
  },
  buildPayload: async (values) => {
    if (values.mode === VIDEO_MODES.CUSTOM) {
      const uploadedVideo =
        values.video_source === 'file' && values.video_file?.length > 0
          ? await uploadMedia(values.video_file, 'video')
          : null;
      const videoFileId = uploadedVideo?.public_id || values.existing_video_file_id;
      const videoFileUrl = uploadedVideo ? null : values.existing_video_file_url;

      if (values.video_source === 'file' && !videoFileId && !videoFileUrl) {
        throw new Error('Video file is missing');
      }

      return {
        name: values.name,
        video_url: values.video_source === 'url' ? values.video_url : null,
        video_file_id: values.video_source === 'file' ? videoFileId : null,
        video_file_url: values.video_source === 'file' ? videoFileUrl : null,
      };
    }

    return values.selectedItems[0];
  },
  parseApiData: (module) => {
    const video = module.video || module;

    if (video?.source || video?.video_url || video?.video_file_id) {
      return {
        mode: VIDEO_MODES.CUSTOM,
        selectedItems: [],
        name: video.name || '',
        video_source: video.video_file_id ? 'file' : 'url',
        video_url: video.video_url || '',
        video_file: [],
        existing_video_file_id: video.video_file_id || null,
        existing_video_file_url: video.video_file_url || null,
      };
    }

    if (video?.uid) {
      return {
        mode: VIDEO_MODES.EXISTING,
        selectedItems: [video],
        name: '',
        video_source: 'url',
        video_url: '',
        video_file: [],
        existing_video_file_id: null,
        existing_video_file_url: null,
      };
    }

    return defaultValues;
  },
  ConfigComponent: createVideoConfig(useAvailableItems),
});
